var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-3 mb-3 d-inline-block baseColor",on:{"click":_vm.toggleLanguage}},[_vm._v(_vm._s(_vm.$t("LANGUAGE_PICKER.TEXT")))])}
var staticRenderFns = []

export { render, staticRenderFns }